module.exports = __webpack_public_path__ + "rijksoverheidsanstext-bold_2_0.woff?059ccb3ad20f9b6278975e55e97afb80";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/rijksoverheidsanstext-bold_2_0.woff
// module id = 542
// module chunks = 0